import React, {useCallback, useRef, useEffect, useMemo, useState} from 'react';
import {Column} from 'devextreme-react/data-grid';
// import { useLocation } from "react-router-dom";
// import { RouterProps } from 'react-router-dom';
// import { RouteComponentProps, withRouter } from 'react-router-dom';
import {Item as TabItem} from "devextreme-react/tab-panel";
import Form, {GroupItem, SimpleItem, Label} from "devextreme-react/form";
import IClient from "../../models/IClient";
import useApi from "../../hooks/useApi";
import {SelectBox} from "devextreme-react/select-box";
import DataSource from "devextreme/data/data_source";
import CustomStore from "devextreme/data/custom_store";
import {FormListBase, FormListBaseTab, FormListBaseGrid} from '../base';
import useCustomDataSource, {Mode} from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';

export default function RapportsReservation() {
    const anyFormDataSource = useCustomDataSource<IClient, IClient>({path: "client", primaryKey: "idClient", customReadAllPath: "client/read-list"});
    const {selectedDataRow: selectedClient, mode, setMode, isFieldModifier, setIsFieldModifier} = anyFormDataSource;
    const [selected, setSelected] = useState("");

    useEffect(() => {
        // var url = window.location.search;
        // var lastPart = url.split("/").pop();
        const query = new URLSearchParams(window.location.search);
        const rapport = query.get('rapport');
        console.log(rapport)
        if (rapport) setSelected(rapport);
        // setSelected(rapport ? rapport : "");
    }, [window.location.search]);

    const items = ["Achalandage des postes d'enregistrement",
        "Achalandage mensuel des activités par lieux de séjours",
        "Achalandage par activité et par provenance",
        "Achalandage par catégorie de client",
        "Achalandage par période",
        "Achalandage par types et lieux de séjour",
        "Activités des réservations",
        "Activités effectués par période",
        "Analyse des statistiques de pêche",
        "Catalogue des produits",
        "Charte comptable",
        "Dépôts clients",
        "Dépôts en retard",
        "État de compte",
        "Feuillets d'enregistrements non remis",
        "Historique d'un client",
        "Impression de billets",
        "Impression de dépôt",
        "Journal des paiements",
        "Journal des ventes",
        "Liste critériée des clients",
        "Liste des achats d'unités réservés",
        "Liste des arrivées",
        "Liste des caches",
        "Liste des chasseurs",
        "Liste des clients",
        "Liste des départs",
        "Liste des fournisseurs",
        "Liste des groupes de chasseurs",
        "Liste des items vendus",
        "Liste des membres",
        "Liste des ménages",
        "Liste des passages FQCQ",
        "Liste des permis",
        "Liste des plans",
        "Liste des points d'eau",
        "Liste des repas par unité",
        "Liste des réservations",
        "Liste des réservations avec balance due",
        "Liste des résidents",
        "Liste des roulottes",
        "Liste des types de transport",
        "Liste des unités",
        "Liste des usagers",
        "Montants à recevoir",
        "Nombres de nuitées annuel par types d'unités",
        "Planification des repas",
        "Points d'eau à fermer",
        "Présences sur le territoire",
        "Provenance des clients",
        "Quotas des points d'eau",
        "Rapport d'activités annuel pourvoirie",
        "Rapport de caisse",
        "Rapport des ventes detaillé",
        "Rapport d'un client",
        "Résultats des tirages",
        "Statistiques de captures(chasse)",
        "Statistiques de fréquentation",
        "Statistiques de prises(pêche)",
        "Statistiques de prises de pêche par type de séjours",
        "Statistiques de prises de saumons",
        "Statistiques de prises de saumons par emplacement",
        "Statistiques de prises sommaire(pêche)",
        "Statistiques des fiches d'enregistrement",
        "Statistiques des perches par point d'eau",
        "Statistiques d'hébergement annuel",
        "Statistiques publicitaires",
        "Tableau des réservations",
        "Taux d'occupation",
        "Valeur de l'inventaire",
        "Ventes par folio détaillé"]

    // const etatCompteOptions = useMemo(() => {
    const valueChanged = (e: any) => {
        const previousValue = e.previousValue;
        const newValue = e.value;
        setSelected(e.value)
        console.log(selected)
        // Event handling commands go here
    }

    return (
        <FormListBase data={anyFormDataSource}>
            {/* <FormListBase data={anyFormDataSource}> */}
            {/* <FormListBaseGrid dataSource={anyFormDataSource.dataSource}>
        <Column key={"grid-col-nom"} dataField={"nom"} caption="Nom" allowHiding={false} />
        <Column key={"grid-col-prenom"} dataField={"prenom"} caption="Prénom" allowHiding={false} />
        <Column key={"grid-col-adresse"} dataField={"adresse"} caption="Adresse" allowHiding={false} />
      </FormListBaseGrid> */}
            <FormListBaseTab>
                <TabItem title="Informations">
                    <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedClient || {} as IClient} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                        <GroupItem caption={"Filtres"}>
                            <SelectBox items={items} defaultValue={selected}
                                       onChange={valueChanged}
                            />
                            <SimpleItem key={"date-debut"}>
                                <Label text={"Date début"}/>
                            </SimpleItem>
                        </GroupItem>
                    </Form>
                </TabItem>
                <TabItem title="Système"><FormSysteme formData={selectedClient || {} as IClient}/></TabItem>
            </FormListBaseTab>
        </FormListBase>
    );
}
